export const urlForGetMockArticle = 'article/get';
export const urlForSaveMockArticle = 'article/save';
export const urlForGetArticleDetail = 'article/detail';
export const urlForGetArticleList = 'article/list';
export const urlForGetArticleTop = 'article/top';
export const urlForArticleIsPassword = 'article/ispassword';
export const urlForArticleCheckPassword = 'article/checkpassword';
export const urlForGetActCate = 'article/category';
export const urlForGetArchives = 'article/archives';
export const urlForGetHot = 'article/hot';
export const urlForGetTags = 'article/tags';
export const urlForGetDynamic = 'dynamic';

export const urlForLogin = 'user/login';
export const urlForRegister = 'user/register';
export const urlForGetLongSign = 'sign';
export const urlForGetWeather = 'getWeather';
export const urlForGetBlogInfo = 'bloginfo';

export const urlForGetAsideIinfo = 'aside/info';

export const urlForGetImgCategory = 'images/getCategory';
export const urlForGetImgs = 'images/getImages';
export const urlForImageIsPass = 'images/isPassword';
export const urlForImagePassCheck = 'images/passCheck';


export const urlForGetVideoCategory = 'video/getCategory';
export const urlForGetVideo = 'video/getDetail';
export const urlForVideoIsPass = 'video/isPassword';
export const urlForVideoPassCheck = 'video/passCheck';

export const urlForGetProjectList = 'getProjectList';

export const urlForpostIp = 'ipcommit';
export const urlForGetVersion = 'version/get';

export const urlForAiTalk = 'ai/talk';
export const urlForGetChatTimes = 'ai/chatTimes';
export const urlForPostChatTimesUse = 'ai/chatTimesUse';
